var trackingQueue = [];
export function trackEvent(event) {
  trackingQueue.push(event);
  if (typeof window === 'undefined' || !window['IS24'] || !window['IS24'].TEALIUM || !window['IS24'].TEALIUM.tracking) {
    return;
  }
  var tracking = window['IS24'].TEALIUM.tracking;
  trackingQueue.forEach(function (eventFromQueue) {
    var label = eventFromQueue.label,
      _eventFromQueue$categ = eventFromQueue.category,
      category = _eventFromQueue$categ === void 0 ? 'residential' : _eventFromQueue$categ,
      _eventFromQueue$actio = eventFromQueue.action,
      action = _eventFromQueue$actio === void 0 ? 'business_directory' : _eventFromQueue$actio,
      _eventFromQueue$produ = eventFromQueue.product,
      product = _eventFromQueue$produ === void 0 ? 'business_directory' : _eventFromQueue$produ,
      name = eventFromQueue.name,
      parameter_1 = eventFromQueue.parameter_1,
      parameter_2 = eventFromQueue.parameter_2;
    tracking.report({
      evt_ga_category: category,
      evt_ga_action: action,
      evt_ga_label: label,
      event_product: product,
      event_name: name,
      event_parameter_1: parameter_1,
      event_parameter_2: parameter_2
    });
  });
  trackingQueue = [];
}